import { render } from "./PrivateDetailsSidebar.vue?vue&type=template&id=7548638e&scoped=true"
import script from "./PrivateDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./PrivateDetailsSidebar.vue?vue&type=script&lang=js"

import "./PrivateDetailsSidebar.vue?vue&type=style&index=0&id=7548638e&scoped=true&lang=css"

import exportComponent from "/home/treim/code/applyhr/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7548638e"]])

export default __exports__